import React, { useState, useRef } from 'react';
import ReactDOM from "react-dom";
import Card from "../components/Card";
import SearchInput from "../components/datatable/SearchInput"
import AjaxDynamicDataTable from '@langleyfoxall/react-dynamic-data-table/dist/AjaxDynamicDataTable';
import LoadingIndicator from "../components/datatable/LoadingIndicator";
import EmptyTable from "../components/datatable/EmptyTable";
import Filter from "../components/datatable/Filter";
import Button from "../components/Button";
import DateInput from '../components/forms/inputs/DateInput';

const FILTER_OPTIONS = {
    all: {
        name:   'All',
        value:  'all',
    },
    pending: {
        name:   'Pending',
        value:  'pending',
    },
    not_started: {
        name:   'Not Started',
        value:  'not_started',
    },
    in_progress: {
        name:   'In Progress',
        value:  'in_progress',
    },
    completed: {
        name:   'Completed',
        value:  'completed',
    },
    archived: {
        name:   'Archived',
        value:  'archived',
    },
}

const COMPLETED_FILTERS = {
    yes: {
        name:   'Yes',
        value:  'yes',
    },
    no: {
        name:   'No',
        value:  'no',
    }
}

const OverviewOrderDataTable = (props) => {
    const {
        jobTypes,
        users,
    } = props;

    const dataTableRef                          = useRef(null);
    const [search, setSearch]                   = useState("");
    const [statusFilter, setFilter]             = useState(FILTER_OPTIONS.all.value);
    const [jobTypeFilter, setJobTypeFilter]     = useState("");
    const [userFilter, setUserFilter]           = useState("");

    const renderRowButton = (order) => {
        return (
            <td>
                <div className={"d-flex justify-content-end align-content-center align-items-center"}>
                    {!!order.can && order.can.view === true && order.deleted_at === "-" && (
                        <a className="text-primary cursor-pointer" href={route('job.order.index', {job: order.job_id}).toString()}>
                            View
                        </a>
                    )}
                </div>
            </td>
        )
    }

    return (
        <React.Fragment>
            <Card classes={"border-0"} noPadding={true}>
                <div className="row">
                    <div className="col-12 col-xl-3 mb-3">
                        <SearchInput
                            value={search}
                            classes={""}
                            placeholder={"Search..."}
                            onChange={(value) => setSearch(value)}
                        />
                    </div>
                    <Filter
                        label={"Status:"}
                        value={statusFilter}
                        options={Object.values(FILTER_OPTIONS)}
                        name={"filter_status"}
                        onChange={(value) => setFilter(value)}
                        classes={"col-12 col-xl-2 mb-3"}
                    />
                    <Filter
                        label={"Job Type:"}
                        value={jobTypeFilter}
                        options={jobTypes}
                        name={"filter_job_type"}
                        onChange={(value) => setJobTypeFilter(value)}
                        classes={"col-12 col-xl-2 mb-3"}
                    />
                    <Filter
                        label={"User:"}
                        value={userFilter}
                        options={users}
                        name={"filter_user"}
                        onChange={(value) => setUserFilter(value)}
                        classes={"col-12 col-xl-2 mb-3"}
                    />
                    <div className="col-1"></div>
                    {can('create', 'job') && (
                        <div className="col-2 col-xs-4 float-right mb-3">
                            <Button
                                href={route('job.create', {origin: "overview-order"}).toString()}
                                label={"Create Job"}
                                icon={"far fa-plus-circle"}
                                classes={"btn btn-eh-lilac px-3 justify-content-center"}
                            />
                        </div>
                    )}
                </div>
                <div className={"row m-0 p-0"}>
                    <div className={"col-12 m-0 p-0"}>
                        <div className="data-table">
                            <AjaxDynamicDataTable
                                apiUrl={route('web-api.overview.order.data-table').toString()}
                                loadingComponent={<LoadingIndicator />}
                                noDataComponent={<EmptyTable itemName="orders" />}
                                fieldsToExclude={statusFilter === FILTER_OPTIONS.archived.value ? [
                                    'can',
                                ] : [
                                    'deleted_at',
                                    'can',
                                ]}
                                alwaysShowPagination
                                fieldOrder={[
                                    'job_id',
                                    'id',
                                    'order_type_icon_class',
                                    'job_name',
                                    'customer_name',
                                    'created_at',
                                    'production_due_at',
                                    'invoiced',
                                    'value',
                                    'status',
                                    'deleted_at',
                                ]}
                                fieldMap={{
                                    job_id:                 "Job Ref",
                                    id:                     "Order Ref",
                                    order_type_icon_class:  "Order Type",
                                    job_name:               "Job Name",
                                    customer_name:          "Customer",
                                    production_due_at:      "Due Date",
                                    invoiced:               "Invoiced %",
                                    value:                  "Total Order Value",
                                    status:                 "Status",
                                    deleted_at:             "Date Deleted",
                                    created_at:             "Created Date",
                                }}
                                ref={dataTableRef}
                                defaultOrderByField={'id'}
                                defaultOrderByDirection={'desc'}
                                params={{
                                    searchTerm:         search,
                                    statusFilter:       statusFilter,
                                    jobTypeFilter:      jobTypeFilter,
                                    userFilter:         userFilter,
                                }}
                                buttons={(row) => renderRowButton(row)}
                                dataItemManipulator={(field, value, row) => {
                                    switch (field) {
                                        case 'order_type_icon_class':
                                            return (
                                                <i className={value} />
                                            );
                                    }

                                    return <span>{value}</span>;
                                }}
                            />
                        </div>
                    </div>
                </div>
            </Card>
        </React.Fragment>
    );
}

export default OverviewOrderDataTable;

const target = document.getElementById('overview-order-datatable');
if (target) {
    ReactDOM.render(
        <OverviewOrderDataTable
            jobTypes={JSON.parse(target.dataset.jobTypes)}
            users={JSON.parse(target.dataset.users)}
        />,
        target
    );
}
